import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailtemplateListenerService {

  @Output() emailTemplatesListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.emailTemplatesListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
